"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRawEraValue = exports.isEraValue = exports.convertRawEraValue = void 0;
const assert_1 = __importDefault(require("assert"));
const ethers_1 = require("ethers");
const bignumber_1 = require("@ethersproject/bignumber/lib/bignumber");
function jsonBigIntToBigInt(value) {
    if ((0, bignumber_1.isBigNumberish)(value)) {
        return ethers_1.BigNumber.from(value);
    }
    (0, assert_1.default)(value.type === 'bigint', 'Value is not a JSONBigInt');
    return ethers_1.BigNumber.from(value.value);
}
function convertRawEraValue(raw) {
    return Object.assign(Object.assign({}, raw), { value: jsonBigIntToBigInt(raw.value), valueAfter: jsonBigIntToBigInt(raw.valueAfter) });
}
exports.convertRawEraValue = convertRawEraValue;
function isEraValue(eraValue) {
    const { era, value, valueAfter } = eraValue !== null && eraValue !== void 0 ? eraValue : {};
    return !!(era && value && valueAfter);
}
exports.isEraValue = isEraValue;
function parseRawEraValue(value, curEra) {
    (0, assert_1.default)(isEraValue(value), `Value is not of type EraValue: ${JSON.stringify(value)}`);
    const eraValue = convertRawEraValue(value);
    if (curEra && curEra > eraValue.era) {
        return { current: eraValue.valueAfter, after: eraValue.valueAfter };
    }
    const sortedValueAfter = eraValue.value.eq(eraValue.valueAfter)
        ? eraValue.value
        : eraValue.valueAfter;
    return { current: eraValue.value, after: sortedValueAfter };
}
exports.parseRawEraValue = parseRawEraValue;
//# sourceMappingURL=parseEraValue.js.map